module.exports = __webpack_public_path__ + "static/media/logo.b840d4ed.svg";